import { render, staticRenderFns } from "./SmsCodeButton.vue?vue&type=template&id=62955fe6&scoped=true&"
import script from "./SmsCodeButton.vue?vue&type=script&lang=js&"
export * from "./SmsCodeButton.vue?vue&type=script&lang=js&"
import style0 from "./SmsCodeButton.vue?vue&type=style&index=0&id=62955fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62955fe6",
  null
  
)

export default component.exports